import { Injectable } from '@angular/core';
import { List } from 'immutable';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ReadingListDetails } from '®shared/reading-list';
import { TarlV3Jsonapi } from '®shared/tarl-v3-jsonapi';

import { ListResults } from './list-results';

@Injectable()
export class UserListsService {
  constructor(private tarlV3JsonApi: TarlV3Jsonapi) {}

  fetchUserLists(
    userGuid: string,
    limit: number,
    offset: number,
    searchTerm?: string,
  ): Observable<ListResults> {
    const path = this.tarlV3JsonApi.path(
      `/users/${userGuid}/relationships/subscribed_lists`,
      {},
    );
    const params = {
      limit,
      offset,
      include: [],
    };

    const extraParams = searchTerm ? { 'filter[search_term]': searchTerm } : {};

    return this.tarlV3JsonApi
      .getPageOfResources<ReadingListDetails>(path, params, extraParams)
      .pipe(
        map(results => ({
          limit,
          offset,
          totalResults: results.meta.total,
          lists: List(results.data),
        })),
      );
  }
}
